import moment from 'moment-timezone';

export const convertToTimeZone = (dateValue) => {
  const originalDateTime = dateValue.toString();
  const originalTimeZone = 'Etc/GMT+0';

  const originalMoment = moment.tz(originalDateTime, originalTimeZone);

  const targetTimeZone = moment.tz.guess();

  const targetMoment = originalMoment.clone().tz(targetTimeZone);

  const targetDateTime = targetMoment;

  return targetDateTime;
};
